import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-notificacion-comisiones',
  templateUrl: './modal-notificacion-comisiones.component.html',
  styleUrls: ['./modal-notificacion-comisiones.component.css'],
})
export class ModalNotificacionComisionesComponent {
  fechaLimite!: Date;
  fechaLimiteFormateada = '';
  mesSiguiente = '';
  anioSiguiente!: number;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      fechaLimite: Date;
      quincena: string;
      mes: string; // mes actual de la notificación
      anio: number; // año actual de la notificación
    },
    public dialogRef: MatDialogRef<ModalNotificacionComisionesComponent>,
    private router: Router,
  ) {
    this.fechaLimite = data.fechaLimite;
    this.fechaLimiteFormateada = this.formatearFecha(this.fechaLimite);

    // Calcular mes siguiente para el texto administrativo
    const meses = [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre',
    ];

    const indexMesActual = meses.findIndex(
      (m) => m.toLowerCase() === data.mes.toLowerCase(),
    );

    if (indexMesActual === 11) {
      // diciembre
      this.mesSiguiente = meses[0];
      this.anioSiguiente = data.anio + 1;
    } else {
      this.mesSiguiente = meses[indexMesActual + 1];
      this.anioSiguiente = data.anio;
    }
  }

  private formatearFecha(fecha: Date): string {
    const meses = [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre',
    ];
    const mes = meses[fecha.getMonth()];
    const dia = fecha.getDate().toString().padStart(2, '0');
    const anio = fecha.getFullYear();
    return `${mes} ${dia} ${anio}`;
  }

  goToComisiones() {
    this.dialogRef.close();
    this.router.navigate(['/main/comisiones']);
  }
}
